import request from '@/utils/request'

export function getList(params) {
  return request({
    url: '/projects/load',
    method: 'get',
    params
  })
}

export function getLogs(params) {
  return request({
    url: '/projects/getlogs',
    method: 'get',
    params
  })
}

export function add(data) {
  return request({
    url: '/projects/add',
    method: 'post',
    data
  })
}

export function update(data) {
  return request({
    url: '/projects/update',
    method: 'post',
    data
  })
}

